import styled from 'styled-components';
import { espacamento } from '../../styles/constants/sizes';

export const ListaHeader = styled.div`
  font-size: .9em;
  border: 1px solid;
  border-radius: 3px;
  padding: ${espacamento.extraPequeno}px;
  flex-direction: row;
  justify-content: space-between;
  width: 250px;
`;
